import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CampaignInformation } from '../core/data/campaign-information';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ss-campaign-layout-two-component',
    templateUrl: './campaign-layout-two.component.html',
    styleUrls: ['./campaign-layout-two.component.css']
})

export class CampaignLayoutTwoComponent implements OnInit {

    @Input() campaignInformation: CampaignInformation;
    @Input() schoolIconLogo: string;
    @Input() showSchoolIconLogo: boolean;

    profileImageUrl: string;
    showImage = true;
    showInitials: boolean;
    showCheckoutModal = false;

    onGiveNowClick() {
        this.showCheckoutModal = true;
    }

    onerror() {
        this.showInitials = true;
        this.showImage = false;
    }

    ngOnInit() {
        this.profileImageUrl = location.origin + '/api/studentimage/campaign/' + this.campaignInformation.profileImageId;
    }

    constructor(
        private route: ActivatedRoute
    ) { }
}
